// Lib
import { createProvider } from 'react-redux';

// Constants
import { EDITOR_STORE_NAME } from '../editorConstants';

export default createProvider(EDITOR_STORE_NAME);
